(function ($) {
  const $modalPayment = $('#modal-payment');
  if (!$modalPayment.length) {
    return;
  }
  const $modalPaymentBody = $modalPayment.find('.modal-body');
  window.initPayment = function (callbackAfterPayment = null) {
    const $paymentForm = $modalPaymentBody.find('form');
    if (!$paymentForm.length) {
      return;
    }
    const stripe = window.Stripe($paymentForm.data('publishable-key'));
    const elements = stripe.elements();
    const style = {
      base: {
        color: "#32325d"
      }
    };

    const card = elements.create("card", {style: style});
    card.mount("#card-element");
    card.on('change', ({error}) => {
      let displayError = document.getElementById('card-errors');
      if (error) {
        displayError.textContent = error.message;
      } else {
        displayError.textContent = '';
      }
    });

    $paymentForm.on('submit', function (ev) {
      ev.preventDefault();
      stripe.confirmCardPayment($paymentForm.data('client-secret'), {
        payment_method: {
          card: card
        }
      }).then(function (result) {
        if (result.error) {
          $paymentForm.find('#card-errors').text(result.error.message);
		  console.log("test");
			$('#modal-alert-message').text("Le paiement n'est pas passé");
			$('#modal-alert').css({
				'z-index': '9999',
				'background-color': 'rgba(250, 247, 247, 0.9)'
			});
			$('#modal-alert').modal('show');
        } else {
          // The payment has been processed!
          if (result.paymentIntent.status === 'succeeded') {
            $modalPaymentBody.html('Paiement réalisé avec succès !');
            $modalPayment.on('hide.bs.modal', function () {
              // window.location.href = window.location.pathname;
              window.location.href = '/mon-compte/commandes/';
            });
            if (callbackAfterPayment) {
              callbackAfterPayment();
            }
          }
        }
      });
    });
  }

})(jQuery);
